export default __webpack_public_path__ + "static/media/Exaltate's Boots.6c468933.jpg";